import React, { useEffect, useMemo, useState } from 'react'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Box from '@material-ui/core/Box'
import { withStyles } from '@material-ui/core/styles'
import { SelectDashboard } from '../../../../../Components/Form'
import { theme } from '../../../../../Assets/Styles/theme'
import {
  INDUSTRY_GROUPS_OPTIONS_TYPES_V2,
  INDUSTRY_GROUPS_V2,
  INDUSTRY_OPTIONS_TYPES_V2,
  INDUSTRY_OPTIONS_V2,
} from '../../../../../shared/constants'

const styles = {
  dialog: {
    '& .MuiDialogContent-root, .MuiDialogTitle-root, .MuiDialogActions-root': {
      padding: 0,
    },
    '& .MuiDialog-paper': {
      margin: 8,
      maxWidth: '720px',
      width: 'calc(100vw - 16px)',
      '@media screen and (min-width: 640px)': {
        width: 'auto',
        margin: 16,
      },
      '@media screen and (max-width: 480px)': {
        margin: 4,
        width: 'calc(100vw - 8px)',
      },
    },
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: 20,
    paddingTop: 20,
    '@media screen and (max-width: 480px)': {
      paddingRight: 12,
      paddingTop: 12,
    },
  },
  contentWrap: {
    padding: ' 0px 0px 20px 0px',
    width: '100%',
    '@media screen and (max-width: 640px)': {
      padding: '0 24px 40px',
    },
    '@media screen and (max-width: 480px)': {
      padding: '0 16px 24px',
    },
  },
  title: {
    textAlign: 'center',
    marginBottom: 16,
    marginTop: 16,
    '& h2': {
      fontWeight: 500,
      fontSize: 24,
      lineHeight: 1.4,
      fontFamily: "'Roboto', sans-serif",
      margin: 0,
      color: '#000000',
      alignSelf: 'center',
    },
  },
  textWrap: {
    fontWeight: 400,
    fontSize: 16,
    color: '#505050',
    textAlign: 'left',
    fontFamily: "'Roboto', sans-serif",
    lineHeight: 1.5,
    marginBottom: 24,
    '& p': {
      margin: 0,
    },
    '@media screen and (max-width: 480px)': {
      fontSize: 14,
      marginBottom: 20,
    },
  },
  note: {
    background: '#FFF6E5',
    border: '1px solid #FFE2A8',
    color: '#7A5A00',
    padding: '12px 16px',
    borderRadius: 4,
    fontSize: 14,
    lineHeight: 1.5,
    marginBottom: 24,
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginBottom: 24,
  },
  label: {
    fontWeight: 500,
    fontSize: 14,
    marginBottom: 8,
    display: 'block',
  },
  select: {
    width: '100%',
    height: 40,
    borderRadius: 4,
    border: '1px solid #C8C8C8',
    padding: '8px 10px',
    fontSize: 14,
    backgroundColor: '#FFFFFF',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    '@media screen and (max-width: 480px)': {
      flexDirection: 'column',
      gap: 16,
      alignItems: 'stretch',
    },
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 4,
    '@media screen and (max-width: 480px)': {
      alignItems: 'center',
      width: '100%',
    },
  },
  cancelButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    border: '1px solid #9E9E9E',
    color: '#333333',
    backgroundColor: '#FFFFFF',
    padding: '9px 16px',
    height: 36,
    fontWeight: 500,
    fontFamily: "'Roboto', sans-serif",
    fontSize: 14,
    lineHeight: '18px',
    textTransform: 'uppercase',
    letterSpacing: '0.16px',
    cursor: 'pointer',
    boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
    transition: 'all .2s',
    '&:hover': {
      backgroundColor: '#F7F7F7',
    },
    '@media screen and (max-width: 480px)': {
      width: '100%',
      order: 2,
    },
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    border: 'none',
    color: '#FFFFFF',
    backgroundColor: theme.colors.primary,
    padding: '9px 16px',
    height: 36,
    fontWeight: 500,
    fontFamily: "'Roboto', sans-serif",
    fontSize: 14,
    lineHeight: '18px',
    textTransform: 'uppercase',
    letterSpacing: '0.16px',
    cursor: 'pointer',
    boxShadow:
      '0px 2px 4px 0px rgba(0,0,0,0.14), 0px 3px 4px 0px rgba(0,0,0,0.12), 0px 1px 5px 0px rgba(0,0,0,0.2)',
    transition: 'all .2s',
    '&:hover': {
      backgroundColor: '#d73650',
    },
    '@media screen and (max-width: 480px)': {
      width: '100%',
    },
  },
}

const FillClientIndustryModal = ({
  classes,
  open,
  client,
  onConfirm,
  onCancel,
}) => {
  const [industryGroup, setIndustryGroup] = useState('')
  const [industry, setIndustry] = useState('')

  const {
    industry: initialIndustry,
    industryGroup: initialIndustryGroup,
  } = client

  useEffect(() => {
    const isIndustryGroupValid = Object.values(
      INDUSTRY_GROUPS_OPTIONS_TYPES_V2,
    ).includes(initialIndustryGroup)
    const isIndustryValid = Object.values(INDUSTRY_OPTIONS_TYPES_V2).includes(
      initialIndustry,
    )
    if (initialIndustry && isIndustryValid) {
      setIndustry(initialIndustry)
    }
    if (initialIndustryGroup && isIndustryGroupValid) {
      setIndustryGroup(initialIndustryGroup)
    }
  }, [initialIndustry, initialIndustryGroup])

  const handleSave = () => {
    if (onConfirm) onConfirm(client.id, industry, industryGroup)
  }
  const industryGroupOptions = Object.entries(
    INDUSTRY_GROUPS_OPTIONS_TYPES_V2,
  ).map(([key, value]) => ({
    label: key,
    value: value,
  }))
  const industryOptions = useMemo(() => {
    if (!industryGroup) return []
    const groupOptions = INDUSTRY_GROUPS_V2[industryGroup]
    return groupOptions.map(group => ({
      label: INDUSTRY_OPTIONS_V2[group],
      value: group,
    }))
  }, [industryGroup])

  return (
    <div>
      <DialogTitle id="fill-client-industry-dialog" className={classes.title}>
        Update Client Industry Details
      </DialogTitle>

      <Box className={classes.contentWrap}>
        <DialogContent>
          <div className={classes.textWrap}>
            <p>
              This client's profile is missing its Industry and Industry Group.
              This information is required to create a campaign.
            </p>
          </div>
          <div className={classes.note}>
            Please note: The selections below will update the client's permanent
            profile and will apply to all of their campaigns.
          </div>

          <div className={classes.fieldGroup}>
            <div>
              <SelectDashboard
                options={industryGroupOptions}
                value={industryGroup}
                onChange={(a, b, value) => {
                  setIndustryGroup(value)
                }}
                label="Industry Group*"
                sorted={true}
                cypress_id="fill-client-industry-modal-industry-group-select"
              />
            </div>
            <div>
              <SelectDashboard
                options={industryOptions}
                value={industry}
                onChange={(a, b, value) => {
                  setIndustry(value)
                }}
                label="Industry*"
                sorted={true}
                disabled={!industryGroup}
                cypress_id="fill-client-industry-modal-industry-select"
              />
            </div>
          </div>

          <div className={classes.buttonRow}>
            <button className={classes.cancelButton} onClick={onCancel}>
              CLOSE
            </button>
            <div className={classes.rightColumn}>
              <button
                className={classes.actionButton}
                onClick={handleSave}
                disabled={!industry || !industryGroup}
              >
                SAVE
              </button>
            </div>
          </div>
        </DialogContent>
      </Box>
    </div>
  )
}

export default withStyles(styles)(FillClientIndustryModal)
